<script lang="ts">
    import {Component, Prop, toNative} from 'vue-facing-decorator'
    import CityAutocomplete, {
        CityAutocomplete as _CityAutocomplete,
    } from '~/components/search/forms/CityAutocomplete.vue'
    import {mapHotels} from '~/utils/hotels/hotel-helpers'

    @Component({
        mixins: [CityAutocomplete],
    })
    export class CityHotelAutocomplete extends _CityAutocomplete {
        @Prop({default: 'ACCOMMODATION'}) declare productType

        override itemLabel(entry) {
            const regex = new RegExp(this.search, 'i')
            return this.selectionLabel(entry).replace(regex, '<strong>$&</strong>')
        }

        override selectionLabel(entry) {
            return (
                (entry.type === 'position' && entry.address) ||
                (entry.type === 'city' &&
                    `${entry.name}, ${entry.parentName}` +
                        (entry.parentName !== entry.countryName ? `, ${entry.countryName}` : '')) ||
                `${entry.name}, ${entry.cityName}, ${entry.countryName}`
            )
        }

        async searchHotels(val) {
            const rqParams = {
                pattern: val,
                limit: 10,
            }

            if (persistentStore.selectedCompanyAndAgent?.company && persistentStore.selectedCompanyAndAgent?.agent) {
                rqParams.companyId = persistentStore.selectedCompanyAndAgent.company.id
            }

            const rs = await this.$api.suggestHotels.get(rqParams, this.cancelTokenSource.token)

            return this.mapHotels(rs.hotels)
        }

        override async searchCities(val) {
            this.tryResearch.status = false
            const value = val.trim().toLowerCase()
            const rq = {
                pattern: `%${value}%`,
                limitCities: 10,
                orderBy: 'POPULARITY',
                ...(this.countryId && {countryId: this.countryId}),
                ...(this.productType && {productType: this.productType}),
                ...(this.productType === 'ACCOMMODATION' && {hotelsQuantity: 1}),
            }
            const rs = await this.$api.locations.get(rq, this.cancelTokenSource.token)

            return rs.cities
        }

        mapHotels(hotels) {
            return mapHotels(hotels)
        }

        override async initSearch(val) {
            if ((this.entries.length > 0 && this.entries.indexOf(val) !== -1) || !val) return
            this.loading = true
            if (this.cancelTokenSource) this.cancelTokenSource.cancel('Operation canceled by the user.')
            this.cancelTokenSource = this.$axios.CancelToken.source()

            try {
                let cities = [],
                    hotels = []
                await Promise.all([
                    (async () => {
                        cities = await this.searchCities(val)
                    })(),
                    (async () => {
                        hotels = await this.searchHotels(val)
                    })(),
                ])
                this.entries = [...cities, ...hotels]

                if (!this.entries.length) {
                    this.tryResearch.status = true
                    this.tryResearch.message =
                        this.isMobile && this.showDialog
                            ? this.$t('try_rewrite_destination_mobile')
                            : this.$t('try_rewrite_destination')
                }
            } catch (e) {
                /* empty */
            } finally {
                this.loading = false
            }
        }

        override icon(type) {
            switch (type) {
                case 'hotel':
                    return this.hotelIcon
                default:
                    return this.locationIcon
            }
        }

        get hotelIcon() {
            return 'mdi-office-building'
        }
    }

    export default {...toNative(CityHotelAutocomplete), ssrRender: CityAutocomplete.ssrRender}
</script>

<style scoped lang="scss">
    :deep(.v-dialog) {
        overflow-y: hidden;
    }
    :deep(.v-label) {
        font-size: inherit;
    }

    :deep(.v-autocomplete__selection) {
        line-height: unset !important;
        height: unset !important;
        display: flex;
        align-items: start;
    }
</style>
